import { render, staticRenderFns } from "./daiqianfa.vue?vue&type=template&id=2412f940&scoped=true&"
import script from "./daiqianfa.vue?vue&type=script&lang=js&"
export * from "./daiqianfa.vue?vue&type=script&lang=js&"
import style0 from "./daiqianfa.vue?vue&type=style&index=0&id=2412f940&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2412f940",
  null
  
)

export default component.exports